const InternalPaymentOptions = [
    { label: 'Credit / Debit Card' , value: 'card' },
    { label: 'HSA/FSA Card', value: 'hsa/fsa' },
  ]
  
  export default InternalPaymentOptions;